import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // Assuming you use React Router for navigation
import TextInput from '../../components/FormElements/TextInput';
import Logo from '../../components/Branding/Logo'; // Import the Logo component

function ForgotPasswordScreen() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState(''); // For displaying success/error messages
    const [isLoading, setIsLoading] = useState(false); // To manage loading state of the form
    const [emailError, setEmailError] = useState(''); // For field-specific errors

    const handleChange = (e) => {
        setEmail(e.target.value);
        if (emailError) setEmailError(''); // Clear error when user types
        if (message) setMessage(''); // Clear general message when user types
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setEmailError('');
        setMessage('');

        if (!email.trim()) {
            setEmailError('La dirección de correo es requerida.');
            return;
        }
        if (!/\S+@\S+\.\S+/.test(email)) {
            setEmailError('Por favor, ingresa una dirección de correo válida.');
            return;
        }

        setIsLoading(true);
        const role = process.env.REACT_APP_USER_ROLE || 'user';
        const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
        try {
            const response = await fetch(`${API_BASE}/api/${role}s/auth/forgot-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            if (!response.ok) {
                const data = await response.json().catch(() => ({}));
                throw new Error(data.message || 'Error en la solicitud');
            }

            const data = await response.json();
            setMessage(data.message || 'Se ha enviado un enlace de restablecimiento a tu correo si la cuenta existe.');
            setEmail(''); // Clear email field on success
        } catch (error) {
            console.error("Password reset error:", error);
            setMessage('Error al enviar el enlace. Por favor, inténtalo de nuevo.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        // This div defines the column width within the AuthPageLayout.
        // Using a narrower column suitable for a "Forgot Password" form.
        // Adjusted to be wider to better match the typical width of restore-password.html
        // Added d-flex justify-content-center align-items-center to center the form-container within this column,
        // similar to how .form-side behaves in RegisterScreen. Adjusted column to be narrower.
        <div className="col-md-7 col-lg-7 col-xl-7 mx-auto d-flex justify-content-center align-items-center">
            {/* form-container styling should come from CSS, mirroring restore-password.html */}
            <div className="form-container text-center"> {/* Removed p-4 p-md-5 */}
                <Logo /> {/* Using the imported Logo component */}

                {/* Heading and paragraph from restore-password.html */}
                <h2 className="text-center mb-2">Recuperar Contraseña</h2> {/* Matched h2 and mb-2 */}
                <p className="text-muted mb-4">
                    Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
                </p>

                {message && (
                    <div
                        className={`alert ${message.startsWith('Failed') ? 'alert-danger' : 'alert-success'} mb-3`}
                        role="alert"
                    >
                        {message}
                    </div>
                )}

                {/* Form structure mirroring restore-password.html */}
                <form onSubmit={handleSubmit} className="checkin-form text-start"> {/* Added text-start */}
                    <TextInput
                        label="Correo Electrónico"
                        type="email"
                        id="email"
                        name="email"
                        ariaLabel="Email address for password reset"
                        value={email}
                        onChange={handleChange}
                        placeholder="tuemail@ejemplo.com"
                        required
                        error={emailError}
                    />
                    {/* Button now directly inside the form, w-100 makes it full width of the form's content box */}
                    <button type="submit" className="btn btn-checkin w-100 mt-4" disabled={isLoading}>
                        {isLoading ? 'Enviando...' : 'Enviar enlace'}
                    </button>
                </form>
                {/* Links matching restore-password.html */}
                <div className="text-center mt-4">
                    <p className="mb-0">¿Aún no tienes cuenta? <Link to="/register" className="text-decoration-none fw-medium" style={{ color: 'var(--color-primario-verde)' }}>Regístrate</Link></p>
                </div>
                <div className="text-center mt-3">
                    {/* Assuming '/' is your home/index page route */}
                    <Link to="/" className="text-decoration-none" style={{ color: 'var(--color-texto-secundario)' }}>Volver al inicio</Link>
                </div>
            </div>
        </div>
    );
}

export default ForgotPasswordScreen;
